import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/horizontal/select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba6b7d88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba6b7d88', __exports__)) {
    console.log('reload')
    api.reload('ba6b7d88', __exports__)
  }
  
}


export default __exports__